module.exports = __webpack_public_path__ + "static/thumb-6c954eecd2a17ba029122c8f57acc967.png";